import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const risToFevirCall = async (risValue = null, apiToken = null, mapping) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!risValue) {
        console.log("no risValue");
        return null;
    }
    console.log("CALLING SERVER with ristofevirconverter")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'ristofevirconverter',
            'apiToken': apiToken,
            'tool': "ristofevirconverter",
            'ris': risValue,
            'mapping': mapping,
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from ristofevirconverter call");
    }).catch((error) => { console.log(error); });
};

const mapRisCall = async (risValue = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!risValue) {
        console.log("no risValue");
        return null;
    }
    console.log("CALLING SERVER with riscodedetector")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'riscodedetector',
            'apiToken': apiToken,
            'ris': risValue,
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from riscodedetector call");
    }).catch((error) => { console.log(error); });
};

export default risToFevirCall;
export { mapRisCall };